<!-- <div class="container coustom_container">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">UPLOAD PRODUCT AND PRICE CHANGE DETAILS </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="col-md-3">
                <button type="button" class="btn btn-primary" style="width: 90%;" (click)="downloadtemplate()">
                    <i class="fa fa-download"></i> Download Template
                </button>
            </div>
            <div class="row d-flex align-items-center flex-wrap grid-margin mt-4">

                <div class="col-md-3">
                    </div>
                <div class="col-xl-5">
                    <div class="padd-right-file" style="display: flex;">
                        <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                            <mat-label>Attachment</mat-label>
                            <input matInput  id="AttachmentFileName" placeholder="Select Attachment"
                                formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                class="col-10" autocomplete="off" readonly>
                        </mat-form-field>
                        <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                            class="badge bg-light-blue image-button">
                           <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;"/>
                        </button>
                        <button type="button" (click)="reset()" *ngIf="isFileSelected"
                            class="badge bg-light-blue image-button">
                            <img style="filter: invert(1);width: 26px;"
                                src="../../../../assets/Home-Connect/icons/delete.svg" />
                        </button>
                    </div>
                </div>
                <div class="d-flex justify-content-end button-style mt-3">
                    <button class="btn btn-secondary mb-3 ml-3" type="submit" (click)="upload()"
                        matButton>Submit</button>
                </div>
            </div>
        </form>
    </div>
</div> -->

<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Upload Product and Price Change Details</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row  align-items-center flex-wrap grid-margin">
                <div class="col-3 d-flex align-items-center">
                    <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="clearFilter()"></app-button>

                </div>
                <div class="col-sm-12 col-md-7 align-self-center" style="display: flex; align-items: center;">
                    <mat-radio-group formControlName="downloadtype"
                        style="display: flex !important; flex-direction: row; gap: 35px;" (change)="Processtye($event)">
                        <mat-radio-button value=1>Price Only</mat-radio-button>
                        <mat-radio-button class="ml-2" value=2>Product Only</mat-radio-button>
                        <mat-radio-button class="ml-2" value=3>Price & Product</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div [@detailExpand]="show ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                <hr>
                <div class="subtitle_header">{{typeOfFile}}</div>
                <div class="row  mt-3 d-flex justify-content-center  align-items-center flex-wrap grid-margin">
                    <div class="col">
                        <button type="button" class="btn btn-secondary mr-3  d-flex" (click)="downloadExcel()"> Download Template
                        </button>
                    </div>
                    <div class="col-xl-9 d-flex align-items-center flex-wrap grid-margin">
                        <div class="col-7">
                            <div class="padd-right-file" style="display: flex;">
                                <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                    <mat-label>Attachment</mat-label>
                                    <input matInput id="AttachmentFileName" placeholder="Select Attachment"
                                        formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                        class="col-10" autocomplete="off" readonly>
                                </mat-form-field>
                                <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                        style="width: 26px;" />
                                </button>
                                <button type="button" (click)="reset()" *ngIf="isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img style="filter: invert(1);width: 26px;"
                                        src="../../../../assets/Home-Connect/icons/delete.svg" />
                                </button>
                            </div>
                           
                        </div>
                        <div class="d-flex button-style mt-3">
                            <button class="btn btn-primary mb-3 ml-3" type="submit" (click)="upload()"
                                matButton>Submit</button>
                        </div>
                    </div>

                </div>

            </div>

        </form>

        <div class="table-responsive mt-2 my-4 ">
            <mat-table #table [dataSource]="dataSource" style="text-align: center;">
                <ng-container matColumnDef="TypeOfProcess">
                    <mat-header-cell *matHeaderCellDef>Type Of Process</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{gettypeOfFile(dataField.typeOfFile)}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="FileName">
                    <mat-header-cell *matHeaderCellDef>File Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{dataField.fileName}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="createdUser">
                    <mat-header-cell *matHeaderCellDef>created User</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{dataField.creationUserId}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Date">
                    <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{ dataField.date | date:'dd/MM/yyyy hh:mm a' }}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Count">
                    <mat-header-cell *matHeaderCellDef>Count</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{dataField.count}} </p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign py-1 mx-3"
                            [ngClass]="getStatusClass(dataField.processStatusType)">
                            {{getprocessstatus(dataField.processStatusType)}} </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 16px;color: #9B02DB;" class="fa fa-download mr-3"
                                title="Download Data" (click)="download(dataField)"></i>
                        </div>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="dataSource?.data?.length==0" class="no-data-message">
                <p>No Data Found</p>
            </div>
        </div>
        <div class="table_pagenation"  [hidden]="dataSource?.filteredData.length<=50">
            <mat-paginator #paginator [length]="dataSource?.data.length || 0" [pageIndex]="0" [pageSize]="10"
                [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>